<template>
    <v-parallax src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg">
      <v-img src="@/assets/ejto.png" alt="Imagen" class="img" width="100" height="100" style="display: block; margin: 0 auto;"></v-img>
            
   <Encabeza/>
<br>
        <v-card>
            <!-- <v-tabs v-model="tab" bg-color="blue-grey"> -->
            <v-tabs v-model="tab" bg-color="blue-darken-4">
                <v-tab value="one"><v-icon>mdi-pistol</v-icon>PISTOLAS</v-tab>
        <v-tab value="two"><v-icon>mdi-knife-military</v-icon>CUCHILLOS</v-tab>
        <v-tab value="three"><v-icon>mdi-sword-cross</v-icon>SABLES Y ESPADAS</v-tab>
                <!--<v-tab value="three"></v-tab> -->
            </v-tabs>
            <v-card-text>
                <v-window v-model="tab">
                    <v-window-item value="one">
                        <ResarcimientoPistola />
                    </v-window-item>
                    <v-window-item value="two">
                        <ResarcimientoCuchillo />
                    </v-window-item>
                    <v-window-item value="three">
                        <ResarcimientoSable />
                    </v-window-item>
                </v-window>
            </v-card-text>
        </v-card>
    </v-parallax>
</template>

<script>
import { defineComponent } from "vue";
import ResarcimientoPistola from "../ejercito/ResarcimientoPistola.vue";
import ResarcimientoCuchillo from "../ejercito/ResarcimientoCuchillo.vue";
import ResarcimientoSable from "../ejercito/ResarcimientoSable.vue";
/* import ReposicionSable from "../ejercito/ReposicionSable.vue"; */
import Encabeza from "@/components/EncabezadoII.vue";

export default defineComponent({
    data: () => ({
        tab: null,
    }),
    components: {
        ResarcimientoPistola,
        ResarcimientoCuchillo,
        ResarcimientoSable,
        //ReposicionSable,
        //SuboficialesPage
        Encabeza,
    },
});
</script>
